import {action} from 'easy-peasy';

export default {
  setName: action((state, payload) => {
    state.name = payload;
  }),
  setSkillId: action((state, payload) => {
    state.skilllid = payload;
  }),
  setIsOnline: action((state, payload) => {
    state.IsOnline = payload || false;
  }),
  setOpen: action((state, payload) => {
    state.open = payload || false;
  }),
  setSelectedGender: action((state, payload) => {
    state.selectedGender = payload || null;
  }),
  setSortBy: action((state, payload) => {
    state.SortBy = payload || 'ONLINE_TIME';
  }),
  setOnlyHomeCare: action((state, payload) => {
    state.OnlyHomeCare = payload || null;
  }),
  setCategory: action((state, payload) => {
    state.category = payload || null;
  }),
  setShowItems: action((state, payload) => {
    console.log({payload});
    state.showItems = payload || true;
  }),
  setHasDigitalPrescription: action((state, payload) => {
    state.hasDigitalPrescription = payload || null;
  }),
  setEducationLevel: action((state, payload) => {
    state.educationLevel = payload || null;
  }),
  setSessionType: action((state, payload) => {
    state.sessionType = payload || null;
  }),
};
